<template>
  <div class="">
    <div class="form-row mt-3 mr-5" style="align-items: center">
      <div class="col-sm-12">
        <div v-if="this.active != 1">
          <button
            type="button"
            class="btn btn-sm btn-primary el-button--default"
            v-if="this.active < 4"
            @click="previous"
            style="float: right"
          >
            <span>Previous</span>
          </button>
        </div>
      </div>
    </div>
    <el-form v-if="active === 1">
      <app-table :id="tableId" :options="options" @action="getListAction" />
    </el-form>
    <el-form v-if="active === 2">
      <task-mytask-view :id="id"></task-mytask-view>
    </el-form>
  </div>
</template>

<script>
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import * as actions from "../../../../Config/ApiUrl";
import { TableHelpers } from "../../Demo/Tables/mixins/TableHelpers";
import {axiosPost} from "@/app/Helpers/AxiosHelper";

export default {
  extends: CoreLibrary,
  name: "WorkspaceList",
  mixins: [TableHelpers],
  data() {
    return {
      active: 1,
      id:0,
      tableId: "job-site-task-list",
      rowData: {},
      options: {
        name: "JobSiteTaskList",
        url: actions.JOB_TASK_LISTING+ '?company_id='+this.$attrs['props'].companyId+'&job_id='+this.$attrs['props'].jobId,
        // url: actions.DATATABLE_DATA,
        showHeader: true,
        columns: [
          {
            title: this.$t("task"),
            type: "custom-html",
            key: "title",
            modifier: (value, row) => {
                return `<a href="#" id="${row.id}" data-attribute="${row.id}" @click=${this.myFunction(row.id)}>${this.$t(value)}</a>`; 
            },
          },
          {
              title: this.$t('category'),
              type: 'custom-html',
              key: 'category',
              modifier: (value) => {
                  return `<span>${this.$t(value.category_name)}</span>`
              }
          },
          {
            title: this.$t("assigned_to"),
            type: "component",
            key: "users",
            isVisible: true,
            className: "w-100",
            componentName: "group-of-users",
          },
          {
            title: this.$t("start_date"),
            type: "custom-html",
            key: "start_date",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
          {
            title: this.$t("due_date"),
            type: "custom-html",
            key: "due_date",
            modifier: (value) => {

              var result = '';
              let ClassName = "warning";

              const moment = require('moment');
              // Define your due date and current date
              const dueDate = moment(value+' 23:59:59'); // Replace with your due date
              const currentDate = moment(); // Current date and time

              // Calculate the difference in time
              const timeDiff = dueDate.diff(currentDate);
              if (timeDiff > 0) {
                const duration = moment.duration(timeDiff);
                if (duration.days() > 0) {
                  result = `${duration.days()} day${duration.days() > 1 ? 's' : ''} left`;
                  if(duration.days() > 30) {
                    ClassName = 'success';
                  }
                } else if (duration.hours() > 0) {
                  result = `${duration.hours()} hour${duration.hours() > 1 ? 's' : ''} left`;
                } else {
                  result = `${duration.minutes()} minute${duration.minutes() > 1 ? 's' : ''} left`;
                }
              } else {
                  result = 'The due date has passed.';
                  ClassName = 'danger';
              }
              // return `<span>${this.$t(result)}</span>`;
              return `<span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(
                result
              )}</span>`;
            },
          },
          {
            title: this.$t("priority"),
            type: "custom-html",
            key: "priority",
            modifier: (value) => {
              let ClassName = "danger";

              if (value === "low") ClassName = `success`;
              else if (value === "medium") ClassName = `warning`;
              else if (value === "high") ClassName = `danger`;
              return `<span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(
                value
              )}</span>`;
            },
          },
          {
            title: this.$t("status"),
            type: "custom-html",
            key: "status",
            isVisible: true,
            modifier: (value) => {
              let ClassName = "danger";

              if (value === "completed") ClassName = `success`;
              else if (value === "incomplete") ClassName = `warning`;
              else if (value === "action_required") {
                ClassName = `info`; value = 'Action Required';}

              return `<span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(
                value
              )}</span>`;
            },
          },
        ],
        actions: [
          {
            title: this.$t("view"),
            icon: "eye",
            type: "none",
            component: "app-add-modal",
            modalId: "demo-add-edit-Modal",
          },
        ],
        filters: [
          {
            title: this.$t("date"),
            type: "range-picker",
            key: "date",
            option: ["today", "thisMonth", "last7Days", "nextYear"],
          },
          {
            title: this.$t("priority"),
            type: "checkbox",
            key: "priority",
            option: [
              { id: "low", value: "Low" },
              { id: "medium", value: "Medium" },
              { id: "high", value: "High" },
            ],
          },
          {
            title: this.$t("status"),
            type: "checkbox",
            key: "status",
            option: [
              { id: "completed", value: "Completed" },
              { id: "incomplete", value: "Incomplete" },
              // {id: 'invited', value: 'Invited'},
            ],
          },
          {
            "title": this.$t('search_by_category'),
            "type": "drop-down-filter",
            "key": "search select",
            "option": [],
          },
          {
            "title": this.$t('search_by_site'),
            "type": "drop-down-filter",
            "key": "search select site",
            "option": [],
          }
        ],
        showFilter: true,
        showSearch: true,
        showCount: true,
        showClearFilter: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "asc",
        actionType: "dropdown",
      },
    };
  },
  created() {
    this.options.columns = [...this.options.columns, this.actionObj];
    this.searchAndSelectFilterOptions();
    this.searchAndSelectSite();
  },
  mounted() {
    let urlParams = new URLSearchParams(window.location.search);
    if(urlParams.has('status') == true) {
        let status = urlParams.get('status');
        this.options.url = actions.TASK_LISTING+'?status='+status;
    }
  },
  methods: {
    getListAction(rowData, actionObj, active) {
      this.$store.commit('updateSharedData', {index: "taskData", newValue: rowData})
      this.$store.commit('updateSharedData', {index: "taskId", newValue: rowData.id})
      if (actionObj.title == this.$t("view")) {
           this.view(rowData.id);
      }
    },
      view(id) {
        this.id = id;
        this.active = 2;

    },
    myFunction(id){
      let doc = document.getElementById(id);
      if(doc){
        doc.addEventListener('click', () => { 
          this.view(doc.dataset.attribute);
        }) 
      }
    },
    searchAndSelectFilterOptions() {
      this.axiosGet(actions.GET_TASK_CATEGORIES).then((response) => {
        let name = this.options.filters.find(
          (element) => element.title === this.$t("search_by_category")
        );

        name.option = response.data.map((name) => {
          return {
            id: name.id,
            value: name.value,
          };
        });
      });
    },
    searchAndSelectSite() {
      this.axiosGet(actions.GET_JOB_SITES+'/'+this.$attrs['props'].jobId).then((response) => {
        let name = this.options.filters.find(
          (element) => element.title === this.$t("search_by_site")
        );

        name.option = response.data.map((name) => {
          console.log(name);
          return {
            id: name.id,
            value: name.value,
          };
        });
      });
    },
    previous() {
        this.active = 1;
    },
  },
};
</script>
